import React from "react";
import {
  FaFile,
  FaFileImage,
  FaFilePdf,
  FaFileWord,
  FaTimes,
} from "react-icons/fa";
import "./attachmentStyles.css";

const AttachmentPreview = ({ files, onRemove }) => {
  if (files.length === 0) return null;

  const getFileIcon = (file) => {
    const fileType = file.type;

    if (fileType.startsWith("image/")) {
      return <FaFileImage className="file-icon image-icon" />;
    } else if (fileType === "application/pdf") {
      return <FaFilePdf className="file-icon pdf-icon" />;
    } else if (
      fileType === "application/msword" ||
      fileType ===
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ) {
      return <FaFileWord className="file-icon word-icon" />;
    } else {
      return <FaFile className="file-icon default-icon" />;
    }
  };

  const getFilePreview = (file, index) => {
    const isImage = file.type.startsWith("image/");

    return (
      <div key={index} className="file-preview-item">
        <div className="file-preview-icon">
          {isImage ? (
            <div className="image-thumbnail">
              <img
                src={URL.createObjectURL(file) || "/placeholder.svg"}
                alt={file.name}
                className="thumbnail-image"
              />
            </div>
          ) : (
            <div className="file-icon-container">{getFileIcon(file)}</div>
          )}
        </div>
        <div className="file-info">
          <p className="file-name" title={file.name}>
            {file.name}
          </p>
          <p className="file-size">{(file.size / 1024).toFixed(1)} KB</p>
        </div>
        <button
          type="button"
          onClick={() => onRemove(index)}
          className="remove-file-button"
          aria-label="Remove file"
        >
          <FaTimes size={14} />
        </button>
      </div>
    );
  };

  return (
    <div className="file-preview-container">
      {files.map((file, index) => getFilePreview(file, index))}
    </div>
  );
};

export default AttachmentPreview;
